import React from "react";
import { LegalLayout } from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      slug="privacy"
      title="Privacy Policy"
      lastUpdated="September 08, 2026"
      sections={[
        { heading: "Introduction", body: [
          `AdGen Store ("we", "our", "us", available at https://adgen.store) respects your privacy. This policy explains how we collect, use and share information when you use our service. AdGen Store is based in Noida, Uttar Pradesh, India, and this policy is intended to comply with applicable Indian data-protection law. [PLACEHOLDER — confirm applicability of and compliance with the Digital Personal Data Protection Act, 2023 (India), and any other applicable law, with legal counsel.]`,
        ]},
        { heading: "Information We Collect", body: [
          `Account information: name, email address, and authentication provider identifier (e.g. Google sign-in).`,
          `Usage information: prompts you submit, generated outputs, credit-usage history, and basic device/browser metadata.`,
          `Payment information: handled by third-party processors (Stripe, Razorpay). We do not store full card details on our servers. [PLACEHOLDER — confirm exact payment processors in use and update if this changes.]`,
        ]},
        { heading: "How We Use Information", body: [
          `To operate and improve the service, personalize your experience, and process payments.`,
          `To communicate service updates, security notices, and — with your consent — marketing messages.`,
          `To comply with legal obligations and enforce our Terms of Service and Community Guidelines. [PLACEHOLDER — replace with reviewed legal text]`,
        ]},
        { heading: "Third-Party Sharing", body: [
          `We share limited data with sub-processors that help us operate the service, including AI model providers (used to generate your requested content), cloud hosting providers, email delivery services, and payment processors.`,
          `[PLACEHOLDER — insert a current list of named sub-processors (e.g. specific AI model providers, hosting provider, email service) and link to their privacy policies where required by law.]`,
        ]},
        { heading: "Cookies & Similar Technologies", body: [
          `We use cookies and local storage for authentication, remembering your preferences, and basic analytics.`,
          `[PLACEHOLDER — describe cookie categories used (essential, analytics, marketing) and how users can control or opt out of non-essential cookies.]`,
        ]},
        { heading: "Data Retention", body: [
          `We retain personal data only as long as necessary to provide the service, comply with legal obligations, resolve disputes, and enforce our agreements. [PLACEHOLDER — insert specific retention periods once determined, e.g. account data retained until account deletion plus X days.]`,
        ]},
        { heading: "Your Rights", body: [
          `Depending on your jurisdiction, you may have rights to access, correct, delete or export your personal data, and to object to or restrict certain processing activities.`,
          `To exercise these rights, contact us at adgenstore@gmail.com. [PLACEHOLDER — insert expected response time, e.g. "within 30 days," consistent with applicable law.]`,
        ]},
        { heading: "International Transfers", body: [
          `[PLACEHOLDER — describe safeguards (e.g. Standard Contractual Clauses, adequacy decisions) used when transferring data across borders, once your hosting/provider locations are finalized.]`,
        ]},
        { heading: "Children", body: [
          `The service is not directed to children under the age required by applicable law, and we do not knowingly collect personal data from children under that age.`,
        ]},
        { heading: "Changes to This Policy", body: [
          `We will notify users of material changes via email or an in-app notice before the changes take effect.`,
        ]},
        { heading: "Contact", body: [
          `Name : AdGen Store Team\nAddress: Sunworld Arista, Sector-168, Noida, Uttar Pradesh, India\nEmail: adgenstore@gmail.com`,
          `[PLACEHOLDER — insert Data Protection Officer (DPO) or applicable data-protection contact details if required by applicable law.]`,
        ]},
      ]}
    />
  );
}
